<svg viewBox="0 0 100 100" style="width: 50px;height: 50px;">
  <path class="svg-range" d="M 29.999999999999982 84.64101615137753 A 40 40 0 1 1 70 84.64101615137754" stroke-width="14" stroke="MediumTurquoise"></path>
  <text text-anchor="middle" class="svg-text ng-star-inserted" x="50" y="57" fill="var(--text-color-secondary, Black)">{{ textValue }}</text>
</svg>
